/**
 * DV-2860's reading of the photoset visibility flag, and the only place the UI
 * interprets it: absent or `null` is visible (every photoset that predates the
 * flag), and only an explicit `false` is hidden. Mirrors asset-service's
 * ClientVisibilityPolicy. Never compare the raw flag `=== true`.
 */
export const isVisibleToClient = (
  flag: boolean | null | undefined
): boolean => flag !== false;
